export const MESSAGES = {
  SUCCESS: {
    CREATED: "Cadastro realizado com sucesso!",
    UPDATED: "Atualização realizada com sucesso!",
    DELETED: "Exclusão realizada com sucesso!",
    LOGIN: "Login realizado com sucesso!",
    LOGOUT: "Logout realizado com sucesso!",
  },

  ERROR: {
    GENERIC: "Ocorreu um erro. Tente novamente.",
    NETWORK: "Erro de conexão. Verifique sua internet.",
    UNAUTHORIZED: "Sessão expirada. Faça login novamente.",
    FORBIDDEN: "Você não tem permissão para essa ação.",
    NOT_FOUND: "Registro não encontrado.",
    VALIDATION: "Verifique os campos e tente novamente.",
    INVALID: "Dados inválidos na requisição",
  },

  VALIDATION: {
    REQUIRED: "Campo obrigatório",
    EMAIL: "E-mail inválido",
    CPF: "CPF inválido",
    PHONE: "Telefone inválido",
    MIN_LENGTH: (min: number) => `Mínimo de ${min} caracteres`,
    MAX_LENGTH: (max: number) => `Máximo de ${max} caracteres`,
  },

  CONFIRM: {
    DELETE: "Tem certeza que deseja excluir?",
    CANCEL: "Tem certeza que deseja cancelar?",
    LOGOUT: "Tem certeza que deseja sair?",
  },
} as const;
